export default "__VITE_PUBLIC_ASSET__d268f56c__"